import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["name", "width"];
import Certificate from './Certificate.svg';
import { jsx as _jsx } from "react/jsx-runtime";
const ACIllustration = _ref => {
  let {
      name,
      width = '100%'
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  if (name === 'certificate') return /*#__PURE__*/_jsx(Certificate, Object.assign({
    width: width
  }, props));
  return null;
};
export default ACIllustration;